module.exports = __webpack_public_path__ + "static/media/heroBcg.20b02e32.jpeg";